export type AtVirtualClinicFondsrelevanz =
  'J' | 'K' | 'N';

export const AT_VIRTUAL_CLINIC_FONDSRELEVANZ_DISPLAY_NAMES: { [fondsRelevanz in AtVirtualClinicFondsrelevanz]: string } = {
  J: 'Ja (Abrechnung des stationären Aufenthalts/ambulanten Besuchs erfolgt über den Landesgesundheitsfonds/PRIKRAF)',
  K: 'Nein (Abrechnung des stationären Aufenthalts/ambulanten Besuchs erfolgt über den Sozialversicherungsträger)',
  N: 'Nein (Abrechnung des stationären Aufenthalts/ambulanten Besuchs erfolgt weder über den Landesgesundheitsfonds/PRIKRAF noch über den Sozialversicherungsträger)'
};
